import { CheckCircle, RemoveCircle } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import _ from "lodash";
import React, { useEffect } from "react";

interface IPasswordValidatorProps {
  password: string;
  validatePassword: string;
  validCallback: (match: boolean) => void;
}

type ValidationState = {
  length: boolean;
  uppercase: boolean;
  lowercase: boolean;
  numbers: boolean;
  match: boolean;
}

export default function PasswordValidator({ password, validatePassword, validCallback }: IPasswordValidatorProps) {
  const validationState: ValidationState = {
    length: !_.isEmpty(password) && password.length >= 8,
    uppercase: !!password.match(/[A-Z]/g),
    lowercase: !!password.match(/[a-z]/g),
    numbers: !!password.match(/[0-9]/g),
    match: !_.isEmpty(password) && password === validatePassword,
  };

  const isPasswordValid = _.every(_.values(validationState));

  useEffect(
    () => { validCallback(isPasswordValid); },
    [isPasswordValid],
  );


  const checks: { key: keyof ValidationState, text: string }[] = [
    { key: 'length', text: 'Must have 8 or more characters' },
    { key: 'lowercase', text: 'Must include lowecase letters' },
    { key: 'uppercase', text: 'Must include uppercase letters' },
    { key: 'numbers', text: 'Must include numbers' },
    { key: 'match', text: 'The passwords must match' },
  ];

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        {
          _.map(checks, check => <Box key={check.key} sx={{ display: 'inline-flex' }}>
            {validationState[check.key] ? <CheckCircle color="success" /> : <RemoveCircle color="error" />}<Typography sx={{ mx: 1 }}>{check.text}</Typography>
          </Box>
          )
        }
      </Box>
    </Box>
  );
}
